import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=3b50a9d9&scoped=true"
import script from "./detailList.vue?vue&type=script&lang=js"
export * from "./detailList.vue?vue&type=script&lang=js"
import style0 from "./detailList.vue?vue&type=style&index=0&id=3b50a9d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b50a9d9",
  null
  
)

export default component.exports